import projectWidgets from "@main/projectWidgets";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
    status: {
      "ui:placeholder": "status",
      "ui:widget": "type-selector",
      "ui:options": {
        label: false,
        configPath: "types.users.status",
      },
    },
  },
  widgets: { ...projectWidgets },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
